import * as Sentry from '@sentry/react';

const dsn = process.env.REACT_APP_SENTRY_DSN;

export const initializeMonitoring = () => {
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV,
    tracesSampleRate: 0.1,
  });
};

export const captureFrontendException = (error: unknown, context?: Record<string, unknown>) => {
  if (!dsn) return;

  Sentry.captureException(error, { extra: context });
};
